import React, { useEffect, useState } from 'react'
import photo from "../../../Assets/Images/Vector.svg";
import axios from "axios";
import { newBaseUrl } from "../../../Consts"
import { useNavigate } from 'react-router-dom';
import { useProducts } from '../../../Context/ProductsContext';
import { toast, ToastContainer } from 'react-toastify';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';

function NewUserForm() {
  const [selectedStatus, setSelectedStatus] = useState(1);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSaveClick = async () => {
    setLoading(true);
    try {
      const body = {
        'name': document.getElementById('name').value,
        'email': document.getElementById('email').value,
        'password': document.getElementById('password').value,
        'status': selectedStatus,
      };
      const response = await axios.post(`${newBaseUrl}/api/admin/create-user`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        },
      });
      toast.success('User Added successfully!', {
        onClose: () => {
          navigate(`/Users/AllUsers`, { replace: true });
          setLoading(false);
        },
      });
    } catch (err) {
      // Check if there are validation errors in the response
      if (err.response && err.response.data && err.response.data.errors) {
        // Loop through each error message and display it
        const errors = err.response.data.errors; // Assuming `errors` is an object or array
        for (const key in errors) {
          if (errors.hasOwnProperty(key)) {
            errors[key].forEach((message) => {
              toast.error(message); // Display each error message
            });
          }
        }
      } else if (err.response && err.response.data && err.response.data.message) {
        // Display a single error message if available
        toast.error(err.response.data.message);
      } else {
        // Handle other errors
        toast.error("An unexpected error occurred.");
      }
      setLoading(false)
    }
  };

  return (
    <div>
      <ToastContainer autoClose={3000} pauseOnFocusLoss={false} pauseOnHover={false} />
      {loading && <LoadingOverlay />} {/* Display loading overlay */}
      <div className="flex justify-start bg-[#fff] rounded-lg py-[50px] px-[100px]">
        <div style={{ width: '100%' }}>

          <label
            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
          >
            Name <span className="text-red-500">*</span>
          </label>

          <input
            type={'text'}
            id={'name'}
            name={'Name'}
            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
            placeholder={`Type name here`}
            style={{
              paddingBottom: "8px",
            }}
          />

          <label
            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
          >
            Email <span className="text-red-500">*</span>
          </label>

          <input
            type={'text'}
            id={'email'}
            name={'Email'}
            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
            placeholder={`Type email here`}
            style={{
              paddingBottom: "8px",
            }}
          />

          <label
            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
          >
            Password
          </label>

          <input
            type={'text'}
            id={'password'}
            name={'Password'}
            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
            placeholder={`Type password here`}
            style={{
              paddingBottom: "8px",
            }}
          />

          <label
            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
          >
            Status <span className="text-red-500">*</span>
          </label>

          <select
            name="Status"
            id="status"
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e.target.value);
            }}
            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 px-2 w-full h-[40px] border-[#DFEAF2] text-[#718EBF]"
          >
            <option value="1">Active</option>
            <option value="2">Inactive</option>
          </select>
          <div>
            <button className="bg-[#0966AE] text-[#fff] rounded-lg py-2 my-3 w-[200px] text-[20px] font-[Cairo]"
              onClick={handleSaveClick}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

  )
}

export default NewUserForm